export const printError = (err: Error, dst?: boolean): string => {
    console.log(err);
    if(dst) 
        return "Errore generico... Scrivi a emiliano su telegram";
    else
        alert("Errore generico... Scrivi a emiliano su telegram")
        
    return "";
}